import LogoPicture from "/logo-light.png"; // Adjust path as needed

function Logo() {
    return (
        <header className="flex items-center">
            <img src={LogoPicture} alt="Logo" className="h-12 w-auto" />
        </header>
    );
}

export default Logo;